/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { formatDateTime } from "../../helpers/helpers";
import api from "../../services/api";
import AppContext from "../../container/context";

import MUIDataTable from "mui-datatables";
import { CircularProgress, Grid, TextField } from "@mui/material";

const dataAtual = new Date();
const anoReferencia =
  dataAtual.getMonth() === 11
    ? dataAtual.getFullYear() + 1
    : dataAtual.getFullYear();

const RelatorioPagamentos = ({ history }) => {
  const [carregando, setCarregando] = useState(true);
  const [fatura, setFatura] = useState({});
  const [fechandoFatura, setFechandoFatura] = useState(false);
  const [filtros, setFiltros] = useState({
    mesInicio: 1,
    anoInicio: anoReferencia,
    mesFim: 12,
    anoFim: anoReferencia,
  });
  const [totais, setTotais] = useState({
    valorTotal: 0,
    recebido: 0,
    aReceber: 0,
  });
  const [registros, setRegistros] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    api
      .get("relatorios/pagamentosEscola", filtrosEnviar)
      .then((registros) => {
        let valorTotal = 0;
        let recebido = 0;
        let aReceber = 0;

        registros.forEach((r) => {
          valorTotal += r.pedidoPagamentoValor;

          r.pedidoDataHora = formatDateTime(r.pedidoDataHora, "D/M/Y h:m");
          r.valorPagamento = (r.pedidoPagamentoValor / 100).toFixed(2);
          r.mesAnoFatura = `${r.pedidoPagamentoReferenciaMes}/${r.pedidoPagamentoReferenciaAno}`;

          if (r.faturaPagamento) {
            recebido += r.pedidoPagamentoValor;

            r.situacao = "Pago";
          } else {
            aReceber += r.pedidoPagamentoValor;

            r.situacao = "Pendente";
          }
        });

        const totais = {
          valorTotal,
          recebido,
          aReceber,
        };

        setCarregando(false);
        setRegistros(registros);
        setTotais(totais);
      })
      .catch((e) => notification("error", `Erro ao carregar a fatura:  ${e}`));
  };

  const filtrar = (novosFiltros) => {
    const filtrosAtualizados = { ...filtros };

    if (novosFiltros.mesInicio)
      filtrosAtualizados.mesInicio = novosFiltros.mesInicio;
    if (novosFiltros.anoInicio)
      filtrosAtualizados.anoInicio = novosFiltros.anoInicio;
    if (novosFiltros.mesFim) filtrosAtualizados.mesFim = novosFiltros.mesFim;
    if (novosFiltros.anoFim) filtrosAtualizados.anoFim = novosFiltros.anoFim;

    setFiltros(filtrosAtualizados);
    carregar(filtrosAtualizados);
  };

  const colunasTabela = [
    {
      name: "pedidoId",
      label: "Cód. pedido",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "valorPagamento",
      label: "Valor R$",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "pedidoPagamentoParcelaNumero",
      label: "Nº parcela",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "mesAnoFatura",
      label: "Mês/ano fatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "situacao",
      label: "Situação",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "escolaNomeFantasia",
      label: "Escola",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const opcoeTabela = {
    filterType: "checkbox",
    selectableRows: "none",
    rowsPerPage: 50,
    downloadOptions: {
      filename: "pagamentosEscola.csv",
      separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      },
    },
  };

  return (
    <>
      <Grid container>
        <Grid item md={12}>
          <div className="main-container">
            <Grid container>
              <Grid item md={3}>
                <h3>Mês início</h3>
                <Grid container>
                  <Grid item md={4}>
                    <TextField
                      id="filled-number"
                      type="number"
                      value={filtros.mesInicio}
                      onChange={(e) => filtrar({ mesInicio: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={3}>
                <h3>Ano início</h3>
                <Grid container>
                  <Grid item md={4}>
                    <TextField
                      id="filled-number"
                      type="number"
                      value={filtros.anoInicio}
                      onChange={(e) => filtrar({ anoInicio: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={3}>
                <h3>Mês fim</h3>
                <Grid container>
                  <Grid item md={4}>
                    <TextField
                      id="filled-number"
                      type="number"
                      value={filtros.mesFim}
                      onChange={(e) => filtrar({ mesFim: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={3}>
                <h3>Ano fim</h3>
                <Grid container>
                  <Grid item md={4}>
                    <TextField
                      id="filled-number"
                      type="number"
                      value={filtros.anoFim}
                      onChange={(e) => filtrar({ anoFim: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Grid container>
            <Grid item md={12}>
              <div className="main-container">
                <Grid container>
                  <Grid item md={4}>
                    <h4>Valor Total</h4>
                    <p>{`R$ ${(totais.valorTotal / 100).toFixed(2)}`}</p>
                  </Grid>
                  <Grid item md={4}>
                    <h4>Pago</h4>
                    <p>{`R$ ${(totais.recebido / 100).toFixed(2)}`}</p>
                  </Grid>
                  <Grid item md={4}>
                    <h4>À pagar</h4>
                    <p>{`R$ ${(totais.aReceber / 100).toFixed(2)}`}</p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          {registros.length > 0 ? (
            <>
              <Grid container>
                <Grid item md={12}>
                  <MUIDataTable
                    title="Pagamentos"
                    data={registros}
                    columns={colunasTabela}
                    options={opcoeTabela}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <h3>Sem registros para exibir.</h3>
          )}
        </>
      )}
    </>
  );
};

export default RelatorioPagamentos;
